var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "flex h-full flex-grow flex-col justify-between gap-2" },
    [
      _c(
        "div",
        {
          staticClass:
            "flex flex-col content-center items-center justify-center gap-2 transition-all duration-300",
          class: {
            "h-full w-full": !_vm.isCollapsed,
            "absolute mb-2 py-3 px-4 rounded border border-prim-300 bg-pure-white":
              _vm.isCollapsed,
            "bottom-full opacity-100":
              _vm.isCollapsed && (_vm.showPopup || _vm.probingLoading),
            "-z-10 bottom-0 opacity-0": _vm.isCollapsed && !_vm.showPopup
          },
          style: _vm.isCollapsed
            ? { left: "50%", transform: "translateX(-50%)" }
            : {}
        },
        [
          _c(
            "div",
            {
              staticClass:
                "pb-4 w-full flex snap-x-mandatory gap-4 overflow-x-auto scrolling-touch scrollbar-lg",
              class: {
                "max-w-52": _vm.sessionStatus === "draft",
                "max-w-64": _vm.sessionStatus !== "draft"
              },
              attrs: { id: "probing-scroll-" + _vm.measurement.id, dir: "ltr" },
              on: { scroll: _vm.onScroll }
            },
            _vm._l(_vm.probingCirclesPages, function(probingCircles, idx) {
              return _c(
                "div",
                {
                  key: _vm.measurement.id + "-probing-circles-" + (idx + 1),
                  staticClass: "flex flex-shrink-0 justify-center snap-center",
                  class: {
                    "w-full ": !_vm.isCollapsed,
                    "w-52": _vm.isCollapsed && _vm.sessionStatus === "draft",
                    "w-64": _vm.isCollapsed && _vm.sessionStatus !== "draft"
                  },
                  attrs: {
                    id: _vm.measurement.id + "-probing-circles-" + (idx + 1)
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "flex w-full flex-wrap content-center items-start justify-center gap-x-2 gap-y-2"
                    },
                    _vm._l(probingCircles, function(box) {
                      return _c(
                        "div",
                        {
                          key: box.key + "_" + box.value,
                          staticClass:
                            "flex flex-shrink-0 items-center justify-center rounded-full cursor-pointer transition-all duration-300",
                          class: {
                            "h-8 w-8": _vm.sessionStatus === "draft",
                            "h-10 w-10": _vm.sessionStatus !== "draft",
                            "cursor-wait": _vm.removeProbingLoading,
                            "pointer-events-none":
                              _vm.measurement.submitted_at ||
                              box.value === "empty" ||
                              box.value === "removing" ||
                              _vm.sessionStatus !== "ongoing",
                            "border-2 border-dashed border-slate-500 bg-slate-200":
                              box.value === "empty",
                            "bg-pure-white": box.value === "removing",
                            "bg-lime-500": box.value === true,
                            "bg-tomato-700": box.value === false
                          },
                          on: {
                            click: function($event) {
                              return _vm.onRemove(box)
                            }
                          }
                        },
                        [
                          box.value === "removing"
                            ? _c("div", { staticClass: "blum-loader-btn" })
                            : _c("BlIcon", {
                                staticClass:
                                  "h-6 w-6 opacity-0 hover:opacity-100 transition-all duration-300",
                                attrs: { icon: "delete", color: "white" }
                              })
                        ],
                        1
                      )
                    }),
                    0
                  )
                ]
              )
            }),
            0
          ),
          _vm._v(" "),
          _vm.isCollapsed
            ? _c(
                "div",
                { staticClass: "flex h-3 items-center justify-center gap-2" },
                _vm._l(_vm.pageCount, function(n) {
                  return _c("div", {
                    key: n,
                    staticClass:
                      "h-3 w-3 rounded-full cursor-pointer transition-all duration-300",
                    class: {
                      "bg-slate-700": n === _vm.page,
                      "bg-slate-400": n !== _vm.page
                    },
                    on: {
                      click: function($event) {
                        return _vm.onChangePage(n)
                      }
                    }
                  })
                }),
                0
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.measurement.submitted_at && !_vm.isCollapsed
            ? _c(
                "div",
                { staticClass: "flex w-60 justify-center" },
                [
                  _c("StatusChip", {
                    attrs: { status: _vm.measurement.marked_as }
                  })
                ],
                1
              )
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "flex-shrink-0 space-y-2",
          class: { "relative z-10 h-full": _vm.isCollapsed }
        },
        [
          _vm.measurement.submitted_at && _vm.isCollapsed
            ? _c(
                "div",
                {
                  staticClass:
                    "absolute -top-1 left-1/2 flex -translate-x-1/2 justify-center"
                },
                [
                  _c("StatusChip", {
                    attrs: { status: _vm.measurement.marked_as }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.isCollapsed
            ? _c(
                "div",
                {
                  staticClass: "mb-4 flex h-3 items-center justify-center gap-2"
                },
                _vm._l(_vm.pageCount, function(n) {
                  return _c("div", {
                    key: n,
                    staticClass:
                      "h-3 w-3 rounded-full cursor-pointer transition-all duration-300",
                    class: {
                      "bg-slate-700": n === _vm.page,
                      "bg-slate-400": n !== _vm.page
                    },
                    on: {
                      click: function($event) {
                        return _vm.onChangePage(n)
                      }
                    }
                  })
                }),
                0
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "flex flex-col",
              class: {
                "gap-4": !_vm.isCollapsed,
                "gap-0 pt-2": _vm.isCollapsed
              }
            },
            [
              _c(
                "div",
                {
                  staticClass: "flex items-center justify-center",
                  class: {
                    "scale-90 gap-3": _vm.isCollapsed,
                    "gap-3 xl:gap-4": !_vm.isCollapsed
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "flex flex-shrink-0 items-center justify-center rounded-full cursor-pointer transition-all duration-300",
                      class: {
                        "h-16 w-16": _vm.sessionStatus === "draft",
                        "h-18 w-18 xl:h-20 xl:w-20":
                          _vm.sessionStatus !== "draft",
                        "cursor-wait": _vm.probingLoading,
                        "pointer-events-none":
                          _vm.measurement.submitted_at ||
                          _vm.sessionStatus !== "ongoing",
                        "bg-tomato-900": _vm.reduceProbingLoading,
                        "bg-slate-500": _vm.measurement.submitted_at,
                        "bg-tomato-700":
                          !_vm.measurement.submitted_at &&
                          !_vm.reduceProbingLoading
                      },
                      on: {
                        click: function($event) {
                          return _vm.onAdd(false)
                        }
                      }
                    },
                    [
                      _c("BlIcon", {
                        staticClass: "h-10 w-10",
                        attrs: { icon: "close", color: "white" }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "flex flex-shrink-0 items-center justify-center rounded-full cursor-pointer transition-all duration-300",
                      class: {
                        "h-16 w-16": _vm.sessionStatus === "draft",
                        "h-18 w-18 xl:h-20 xl:w-20":
                          _vm.sessionStatus !== "draft",
                        "cursor-wait": _vm.probingLoading,
                        "pointer-events-none":
                          _vm.measurement.submitted_at ||
                          _vm.sessionStatus !== "ongoing",
                        "bg-lime-700": _vm.plusProbingLoading,
                        "bg-slate-500": _vm.measurement.submitted_at,
                        "bg-lime-500":
                          !_vm.measurement.submitted_at &&
                          !_vm.plusProbingLoading
                      },
                      on: {
                        click: function($event) {
                          return _vm.onAdd(true)
                        }
                      }
                    },
                    [
                      _c("BlIcon", {
                        staticClass: "h-16 w-16",
                        attrs: { icon: "check", color: "white" }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  !_vm.measurement.submitted_at &&
                  Object.keys(_vm.measurement.results).length >=
                    (_vm.measurement.target.probing_number_of_trial || 0)
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "flex flex-shrink-0 items-center justify-center rounded-full bg-light-purple hover:bg-dark-purple-200 cursor-pointer transition-all duration-300",
                          class: {
                            "h-16 w-16": _vm.sessionStatus === "draft",
                            "h-18 w-18 xl:h-20 xl:w-20":
                              _vm.sessionStatus !== "draft",
                            "pointer-events-none":
                              _vm.sessionStatus !== "ongoing"
                          },
                          on: { click: _vm.onSubmitProbing }
                        },
                        [
                          _c("BlTextSubtitle3", {
                            staticClass: "text-pure-white",
                            attrs: { text: "Submit" }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ]
              )
            ]
          ),
          _vm._v(" "),
          !_vm.isCollapsed
            ? _c("div", { staticClass: "pb-3 flex-shrink-0 space-y-2" }, [
                _c("div", { staticClass: "flex items-center gap-2" }, [
                  _c(
                    "div",
                    { staticClass: "w-9 flex-shrink-0" },
                    [_c("BlTextBody2", { attrs: { text: "Score" } })],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "h-6 flex items-center rounded-full bg-lime-200 px-2"
                    },
                    [
                      _c("BlTextBody2", {
                        staticClass: "text-lime-700",
                        attrs: { text: _vm.probingScore.toFixed(0) }
                      })
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "flex gap-2" }, [
                  _c(
                    "div",
                    { staticClass: "w-9 flex-shrink-0" },
                    [_c("BlTextBody2", { attrs: { text: "Goal" } })],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    [
                      _c("BlTextBody2", { attrs: { text: "score ≥" } }),
                      _vm._v(" "),
                      _c("BlTextBody2", {
                        attrs: {
                          text: _vm.measurement.target.probing_goal + "%"
                        }
                      }),
                      _vm._v(" "),
                      _c("BlTextBody2", { attrs: { text: "in minimum" } }),
                      _vm._v(" "),
                      _c("BlTextBody2", {
                        attrs: {
                          text: _vm.measurement.target.probing_number_of_trial
                        }
                      }),
                      _vm._v(" "),
                      _c("BlTextBody2", { attrs: { text: "trial(s)" } })
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _vm.sessionStatus === "draft" &&
                _vm.measurement.target.probing_enable
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "z-10 w-full py-2 px-4 rounded-full bg-pure-white flex items-center justify-between"
                      },
                      [
                        _c(
                          "div",
                          [
                            _c("BlTextSubtitle3", {
                              staticClass: "text-lime-700",
                              attrs: { text: "Set as probing" }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.measurement.type
                          ? _c(
                              "div",
                              { staticClass: "flex flex-shrink-0 gap-1" },
                              [
                                _c("BlTextSubtitle3", {
                                  staticClass: "text-lime-700",
                                  attrs: {
                                    text: _vm.measurement.type.includes(
                                      "Probing"
                                    )
                                      ? "Yes"
                                      : "No"
                                  }
                                }),
                                _vm._v(" "),
                                _c("BlInputToggle", {
                                  attrs: {
                                    checked: _vm.measurement.type.includes(
                                      "Probing"
                                    ),
                                    color: "lime",
                                    loading: _vm.switchLoading
                                  },
                                  on: { changed: _vm.onChangeToPercentage }
                                })
                              ],
                              1
                            )
                          : _vm._e()
                      ]
                    )
                  : _vm._e()
              ])
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _vm.showPanel
        ? _c(
            "div",
            {
              staticClass:
                "absolute left-0 top-0 z-10 h-full w-full rounded border-2 border-white overflow-y-auto",
              style: {
                background: "linear-gradient(180deg, #F2F8CF 0%, #FFFFFF 100%)"
              }
            },
            [
              _vm.showCelebration
                ? _c(
                    "div",
                    { staticClass: "grid h-full w-full place-content-center" },
                    [
                      _c("BlGif", {
                        staticClass: "rounded-full h-72 w-72",
                        attrs: { gif: "celebration" }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.showCelebration
                ? _c(
                    "div",
                    {
                      staticClass:
                        "flex h-full w-full flex-col items-center justify-center lg:justify-start xl:justify-center gap-2"
                    },
                    [
                      _vm.isProbingPassed
                        ? _c("BlIcon", {
                            staticClass: "w-full absolute bottom-0 z-0",
                            attrs: { icon: "prob-passed" }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.isProbingPassed
                        ? _c("BlIcon", {
                            staticClass: "w-20",
                            class: {
                              "absolute top-2 right-2 z-0 opacity-50":
                                _vm.measurement.target.status === "mastered"
                            },
                            attrs: { icon: "prob-failed" }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "py-4 px-4 w-full flex flex-col gap-3" },
                        [
                          _vm.isProbingPassed
                            ? _c(
                                "div",
                                { staticClass: "space-y-1 text-center" },
                                [
                                  _c("BlTextSubtitle2", {
                                    staticClass: "text-lime-800",
                                    attrs: {
                                      text: "This target has probed out."
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("BlTextSubtitle3", {
                                    staticClass: "text-lime-700",
                                    attrs: {
                                      text:
                                        "What action would you like to take?"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.isProbingPassed
                            ? _c(
                                "div",
                                { staticClass: "space-y-1 text-center" },
                                [
                                  _c("BlTextSubtitle2", {
                                    staticClass: "text-lime-800",
                                    attrs: {
                                      text: "This target doesn't meet the goal."
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    [
                                      _vm.measurement.target.status ===
                                      "mastered"
                                        ? _c("BlTextSubtitle3", {
                                            staticClass: "text-lime-700",
                                            attrs: {
                                              text:
                                                "What action would you like to take?"
                                            }
                                          })
                                        : _c("BlTextSubtitle3", {
                                            staticClass: "text-lime-700",
                                            attrs: {
                                              text:
                                                "Do you want to begin teaching now or postpone it to the next session?"
                                            }
                                          })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm._l(_vm.probingActionOptions, function(opt) {
                            return _c(
                              "div",
                              {
                                key: opt.id,
                                staticClass:
                                  "p-3 flex flex-col items-center justify-center gap-2 rounded-lg border bg-pure-white text-center cursor-pointer transition-all duration-300",
                                class: {
                                  "border-lime-600":
                                    (_vm.probingAction &&
                                      _vm.probingAction.id) === opt.id,
                                  "border-pure-white":
                                    (_vm.probingAction &&
                                      _vm.probingAction.id) !== opt.id
                                },
                                style: {
                                  boxShadow: "0px 4px 8px -2px #B9D84333"
                                },
                                on: {
                                  click: function($event) {
                                    _vm.probingAction = opt
                                  }
                                }
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "flex items-center gap-2" },
                                  [
                                    _c("BlTextSubtitle3", {
                                      attrs: { text: opt.title }
                                    }),
                                    _vm._v(" "),
                                    opt.status
                                      ? _c("StatusChip", {
                                          attrs: { status: opt.status }
                                        })
                                      : _vm._e()
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                opt.message
                                  ? _c("BlTextBody2", {
                                      attrs: { text: opt.message }
                                    })
                                  : _vm._e()
                              ],
                              1
                            )
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "grid grid-cols-2 gap-2" },
                            [
                              _c("BlInputButton", {
                                attrs: {
                                  type: "plain-lime",
                                  label: "Back to Session"
                                },
                                on: {
                                  clicked: function($event) {
                                    _vm.showPanel = false
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("BlInputButton", {
                                attrs: {
                                  type: "lime",
                                  label: "Save",
                                  loading: _vm.saveLoading,
                                  disabled: !_vm.probingAction
                                },
                                on: { clicked: _vm.onSave }
                              })
                            ],
                            1
                          )
                        ],
                        2
                      )
                    ],
                    1
                  )
                : _vm._e()
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showPanel && _vm.measurement.is_fixed
        ? _c("div", {
            staticClass: "absolute -bottom-20 left-0 h-20 w-full bg-prim-300"
          })
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-67df7ca0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-67df7ca0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sessions/card/Probing.vue
// module id = null
// module chunks = 